import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

// State
import { fetchListIfNeeded } from '../../state/modules/stock/actions';

export default function StockPage() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchListIfNeeded());
  }, []);

  return null;
}
